import { tv } from "@opensea/ui-kit"

export const headerViewFullVariants = tv({
  slots: {
    container: "z-[1] flex w-full items-end",
    content:
      "flex w-full min-w-0 flex-col pb-4 lg:grid lg:grid-cols-[1fr_auto] lg:items-end lg:justify-between xl:gap-4 xl:pb-5",
  },
})
